<template lang="pug">
  #member-marketplace.has-text-grey.card
    .card-content
      WtTitle(h3) Connect A Device
        div.columns.is-multiline
           div.column.is-one-third(v-for="item in markup" :key="item.type")

              div.card
                div.card-image.is-flex.is-horizontal-center
                  a(:href="item.connect_url + returnUrl + item.type")
                    img(
                      :alt='item.tagline'
                      :src='item.logo_url'
                    )


</template>

<script>
import { mapActions } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
export default {
  name: "MemberMarketplace",
  components: { WtTitle, WtTile, WtButton },
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      markup: null,
      showMarketplace: false,
      returnUrl:
        "&redirect_uri=https://" +
        window.location.host +
        "/member-settings/device?type="
    };
  },
  async mounted() {
    this.isLoading = true;
    try {
      let result = await this.getMemberMarketplace({
        api: "validic",
        uid: this.token
      });
      this.markup = JSON.parse(result.data.result);
      this.showMarketplace = true;
      this.isLoading = false;
    } catch (error) {
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: error.data.message
      });
    }
  },
  methods: {
    ...mapActions("members", ["getMemberMarketplace"]),
    ...mapActions(["snackBar"])
  }
};
</script>

<style lang="sass" scoped>
#member-marketplace
  .connect-device-container
    +mobile
      min-height: 200px
  .is-horizontal-center
    justify-content: center
  .card-content
    padding: 20px
</style>
